import React from 'react';
import get_bundle from '../domain/get_bundle';
import getMadaiURL from '../domain/getMadaiURL';
import Locale from '../domain/Locale';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})

export default class Policy extends React.Component {
	getHRef = () => {
		if (this.props.locale.toJSON() === 'it_IT') {
			return 'https://it.madai.com/privacy.html'
  	}	
  	return 'https://madai.com/privacy.html'
	}

  render() {
  	
    //const href = "https://madai.com/faq_us.html"
    //const href = getMadaiURL() + this.props.locale.country.toLowerCase() + '/privacy.html';

    return (<a target='_blank' href={this.getHRef()}>{get_bundle(this.props.locale).footer.policy}</a> );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Policy.js
 **/